import { useState, useEffect } from "react";
import HelpButton from "../components/HelpButton";
import axios from "axios";
import api from "../lib/api";
import { API } from "../App";
import Sidebar from "../components/Sidebar";
import WhatsAppSendModal from "../components/WhatsAppSendModal";
import { toast } from "sonner";
import { WhatsappLogo, Users } from "@phosphor-icons/react";

const HRStaff = ({ user, logout }) => {
  const [staff, setStaff] = useState([]);
  const [search, setSearch] = useState("");
  const [wa, setWa] = useState(null);

  const load = async () => {
    try {
      const r = await api.get(`/users`);
      setStaff((r.data || []).filter(u => u.role !== "customer"));
    } catch { toast.error("Load failed"); }
  };
  useEffect(() => { load(); }, []);

  const visible = staff.filter(u => !search || u.name?.toLowerCase().includes(search.toLowerCase()) || u.email?.toLowerCase().includes(search.toLowerCase()));

  const openWa = (u, action) => {
    if (!u.whatsapp_number) { toast.error("WhatsApp number not set. Update in /user-management."); return; }
    setWa({
      module: "hr",
      receiver: { name: u.name, phone: u.whatsapp_number, type: "staff", id: u.user_id },
      defaultAction: action,
      context: { variables: { name: u.name, custom_message: "", joining_date: (u.created_at || "").slice(0, 10), notice: "" } },
    });
  };

  return (
    <div className="flex min-h-screen bg-slate-50">
      <Sidebar user={user} logout={logout} />
      <div className="flex-1 ml-64 p-8">
        <div className="mb-8">
          <div className="text-[11px] uppercase tracking-[0.25em] text-slate-500 mb-1">Human Resources</div>
          <div className="flex items-center"><h1 className="text-4xl sm:text-5xl tracking-tighter font-bold" style={{fontFamily: 'Outfit, sans-serif'}}>Staff Communication</h1><HelpButton moduleKey="hr" /></div>
          <p className="text-base text-slate-700 mt-1">{staff.length} staff · WhatsApp messages, joining notes, internal notices</p>
        </div>

        <div className="bg-white border border-slate-200 p-4 mb-4">
          <input data-testid="hr-search" value={search} onChange={e => setSearch(e.target.value)} placeholder="Search staff…" className="w-full max-w-sm rounded-none border border-slate-300 focus:border-[#002FA7] p-2 outline-none text-sm" />
        </div>

        <div data-testid="hr-table" className="bg-white border border-slate-200 overflow-x-auto">
          <table className="w-full">
            <thead><tr className="bg-slate-50 border-b border-slate-200">
              {["Name", "Email", "Role", "Department", "WhatsApp", "Actions"].map(h => <th key={h} className="text-left p-3 text-xs uppercase tracking-wider font-bold text-slate-500">{h}</th>)}
            </tr></thead>
            <tbody>
              {visible.length === 0 ? <tr><td colSpan={6} className="p-12 text-center text-slate-400 text-sm">No staff found.</td></tr> :
              visible.map((u, i) => (
                <tr key={u.user_id} data-testid={`hr-row-${i}`} className="border-b border-slate-100 hover:bg-slate-50/50">
                  <td className="p-3 font-semibold">{u.name}</td>
                  <td className="p-3 text-sm text-slate-600">{u.email}</td>
                  <td className="p-3 text-xs uppercase tracking-wider"><span className="bg-slate-100 text-slate-700 px-2 py-0.5">{u.role}</span></td>
                  <td className="p-3 text-sm">{u.department || "—"}</td>
                  <td className="p-3 font-mono text-xs">{u.whatsapp_number ? `+${u.whatsapp_number}` : <span className="text-rose-500">— not set</span>}</td>
                  <td className="p-3 whitespace-nowrap">
                    <button data-testid={`hr-wa-msg-${i}`} disabled={!u.whatsapp_number} onClick={() => openWa(u, "staff_message")} className="text-[10px] uppercase tracking-wider px-2 py-1 border border-emerald-300 text-emerald-700 hover:bg-emerald-50 font-bold disabled:opacity-40 disabled:cursor-not-allowed inline-flex items-center gap-1"><WhatsappLogo size={12} weight="fill" />Message</button>
                    <button data-testid={`hr-wa-notice-${i}`} disabled={!u.whatsapp_number} onClick={() => openWa(u, "internal_notice")} className="text-[10px] uppercase tracking-wider px-2 py-1 border border-blue-300 text-blue-700 hover:bg-blue-50 ml-1 font-bold disabled:opacity-40 disabled:cursor-not-allowed">Notice</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
      {wa && <WhatsAppSendModal open={true} onClose={() => setWa(null)} {...wa} user={user} />}
    </div>
  );
};

export default HRStaff;
